export class ConsumerException extends Error {

    constructor(public error: string, message: string, public status: number) {
        super(message);
        Object.setPrototypeOf(this, ConsumerException.prototype);
    }

    public json(): any {
        return {
            status: this.status,
            error: this.error,
            message: this.message
        };
    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/recursos/modelo/consumerModel/consumerException.ts